export interface SaveUserDataProps {
  key: KeyType
  id: string
  actionType: ActionType
  eventName: string
}

export interface SaveMultipleUserDataProps {
  key: KeyType
  ids: string[] | number[]
  actionType: ActionType
  eventName: string
}

export type SavedUserData = Record<string, KeyContent>

export type KeyContent = Record<ActionType, ActionContent>

export type ActionContent = Record<
  string,
  { count: number; lastUpdated?: string }
> & {
  overallCount: number
}

export const KeyTypes: Record<string, KeyType> = {
  CATEGORY: 'Category',
  SUBCATEGORY: 'Subcategory',
  CLASS: 'Class',
  LESSON: 'Lesson',
  OUTCOME: 'Outcome',
  FUNNEL_STATE: 'Funnel State',
  GIFT: 'Gift',
}

export type KeyType =
  | 'Category'
  | 'Subcategory'
  | 'Class'
  | 'Lesson'
  | 'Outcome'
  | 'Funnel State'
  | 'Gift'

export const ActionTypes = {
  DECLARED: 'declared',
  BROWSING: 'browsing',
  USER_STARTED_QUIZ: 'user_started_quiz',
  USER_COMPLETED_QUIZ: 'user_completed_quiz',
  USER_VIEWED_PLANS: 'user_viewed_plans',
  USER_VIEWED_CART_EMAIL: 'user_viewed_cart_email',
  USER_CREATED_ACCOUNT: 'user_created_account',
  USER_VIEWED_PAYMENT_METHODS: 'user_viewed_payment_methods',
  USER_SELECTED_PAYMENT_METHOD: 'user_selected_payment_method',
  USER_CLICKED_PLACE_SECURE_ORDER: 'user_clicked_place_secure_order',
  USER_COMPLETED_ORDER: 'user_completed_order',
} as const

export type ActionType =
  | 'declared'
  | 'browsing'
  | 'user_started_quiz'
  | 'user_completed_quiz'
  | 'user_viewed_plans'
  | 'user_viewed_cart_email'
  | 'user_created_account'
  | 'user_viewed_payment_methods'
  | 'user_selected_payment_method'
  | 'user_clicked_place_secure_order'
  | 'user_completed_order'
